<template>
  <section>
    <x-panel margin>
        <div slot="title">Tenant Security Settings</div>
    </x-panel>
    <el-tabs v-model="activeName">
        <el-tab-pane label="API Keys" name="apikeys">
            <api-keys v-if="activeName == 'apikeys'" :referrers="referrers"/>
        </el-tab-pane>
        <el-tab-pane label="IP Access Controls" name="blacklist">
            <ip-blacklist v-if="activeName == 'blacklist'"/>
        </el-tab-pane>
        <el-tab-pane label="Authentication Log" name="authLog">
            <authentication-log v-if="activeName == 'authLog'"/>
        </el-tab-pane>
    </el-tabs>
  </section>
</template>

<script>
import ApiKeys from './ApiKeys'
import IpBlacklist from './IpBlacklist'
import AuthenticationLog from './AuthenticationLog'
export default {
  name: 'AmbitionSecurity',
  components: {
      ApiKeys,
      IpBlacklist,
      AuthenticationLog
  },
  props: {
    token: {
        required: true
      },
    referrers: Array,
  },
  data() {
    return {
        activeName: 'apikeys'
    };
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  updated() {
  },
  activated() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
</style>
